import src from "IMAGE";
export default { src, width: 243, height: 460, blurWidth: 0, blurHeight: 0};
